import '../../../styles/index.css'
import './BotaoFiltros.css';
import FilterIcon from '../../../assets/icons/Filter Icon.svg'

function BotaoFiltros() {

    return (

        <button className='botaoFiltros' data-bs-toggle="collapse" data-bs-target="#menuFiltros" data-cy="botao-filtros-trigger">
            <img src={FilterIcon} alt="" />
            <span className='bt3'>Filtros</span>
        </button>


    );
}

export default BotaoFiltros;
